<mat-form-field class="root">
  <mat-label>
    {{ placeholder }}
  </mat-label>
  <mat-select [formControl]="valuesControl" [required]="valuesControl.errors?.required" #singleSelect>
    <mat-option>
      <ngx-mat-select-search
        [clearSearchInput]="true"
        [formControl]="searchControl"
        [placeholderLabel]="placeholderLabel"
        [noEntriesFoundLabel]="noEntriesFoundLabel"
      >
        <mat-icon inline ngxMatSelectSearchClear>clear</mat-icon>
      </ngx-mat-select-search>
    </mat-option>
    <mat-optgroup *ngFor="let item of options$ | async" [label]="item.label">
      <mat-option *ngFor="let option of item.options" [value]="option.value">
        {{ option.label }}
      </mat-option>
    </mat-optgroup>
  </mat-select>
</mat-form-field>
